import { GetEnvelopeOptionChosen } from '../analytics-context-types';
import { getPODModalTag, getPODProductTag } from './utils';

export const getEnvelopeOptionChosenTag = (options: GetEnvelopeOptionChosen) => {
  let level2;
  if (options.eventAction === 'blank') level2 = 'Preview';
  else if (options.eventAction === 'return address only') level2 = 'Address the Envelope - Sender';
  else level2 = 'Address the Envelope - Recipient';

  const { product } = getPODProductTag(
    options.productName,
    options.productID,
    options.productType,
    options.productQuantity,
  );
  const event = [
    {
      eventInfo: {
        eventName: 'envelope option',
        eventAction: options.eventAction,
      },
    },
  ];

  const { modal, user } = getPODModalTag(level2, event, options.projectID);

  return {
    modal,
    product,
    user,
  };
};
